export enum VehicleStatuses {
  OK = 'ok',
  TRANSMISSION_WARNING = 'transmission_warning',
  TRANSMISSION_CRITICAL = 'transmission_critical',
  SATELLITES = 'satellites',
  POWER_WARNING = 'power_warning',
  POWER_CRITICAL = 'power_critical',
  SABOTAGE = 'sabotage',
  SABOTAGE_OFF = 'sabotage_off',
}

export enum InternalVehicleStatus {
  POWER_CRITICAL = 'power_critical',
  DISCONNECTED = 'disconnected',
  POWER_WARNING = 'power_warning',
  OK = 'ok',
  DELAYED = 'delayed',
  UNAVAILABLE = 'unavailable',
  NO_DATA = 'no_data',
  TRANSMISSION_CRITICAL = 'transmission_critical',
  DROPLET = 'droplet',
  TEMPERATURE = 'TEMPERATURE',
  STATION = 'STACJA',
  NOTIFICATION = 'notification',
}
